<template>
  <hr class="tw-text-neutral-300 tw-my-6 tw-w-full">
</template>
